import { render, staticRenderFns } from "./SearchBarDropdownButton.vue?vue&type=template&id=c961951e&scoped=true&"
import script from "./SearchBarDropdownButton.vue?vue&type=script&lang=js&"
export * from "./SearchBarDropdownButton.vue?vue&type=script&lang=js&"
import style0 from "./SearchBarDropdownButton.vue?vue&type=style&index=0&id=c961951e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c961951e",
  null
  
)

export default component.exports